<template>
  <div>
    <div class="operation">
      <a-button type="primary" @click="$add()"> 新增 </a-button>
      <a-input-search
        style="width: 200px"
        placeholder="请输入搜索关键字"
        v-model:value="keyword"
        enter-button
        @search="$search(keyword)"
      />
    </div>
    <a-table
      borderedÎ
      :data-source="dataSource"
      :columns="columns"
      :pagination="false"
    >
      <template> </template>
      <template #operation="{ record }">
        <a @click="$detail(record.id)">详情</a>
        <a-divider type="vertical" />
        <a-popconfirm
          v-if="dataSource.length"
          title="确认删除？"
          @confirm="() => onDelete(record)"
        >
          <a>删除</a>
        </a-popconfirm>
      </template>
    </a-table>
  </div>
</template>
<script>
// 新的数据在上面 老的下面
export default {
  data() {
    return {
      targetName: "customer",
      keyword: "",
      searchFile: 'name',
      dataSource: [],
      columns: [
        {
          title: "姓名",
          dataIndex: "name",
          width: "30%",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "公司",
          dataIndex: "company",
        },
        {
          title: "联系方式",
          dataIndex: "phone",
        },
        {
          title: "操作",
          dataIndex: "operation",
          slots: { customRender: "operation" },
        },
      ],
    };
  },
  // 初始化数据
  async mounted() {
    await this.init();
  },
  methods: {
    // 初始化函数
    async init() {
        this.keyword = this.$route.query.keyword;
        this.$loadList()
    },
    // 删除
    async onDelete(data) {
      const query = await new this.$lc.Query("project");
      query.equalTo("customerId", data.id);
      let rep = await query.first()
      if (rep) {
        return this.$message.info(`删除失败,该客户还有关联项目`);
      }
      await this.$del(data.id)
    },
  },
};
</script>
<style lang="scss">
.operation {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
</style>
